import { createFileRoute } from '@tanstack/react-router';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';
import { choicesReadGuard } from '@bmwe/ui';

export const Route = createFileRoute('/auswahlfelder/branchen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierPartyIndustry"
      returnRoute="/auswahlfelder/dossierPartyIndustry"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierPartyIndustryRoute = Route;
